import { createContext, useContext } from 'react';

/**
 * 업데이트 소식 팝업(`ModalUpdatePopupPublicMember`)이 지금 떠 있는가.
 *
 * ─────────────────────────────────────────────────────────────
 * 왜 컨텍스트인가
 * ─────────────────────────────────────────────────────────────
 * 그 팝업은 `App.tsx` 가 들고 있고, 아침 브리핑 팝업(`MorningBriefingGate`)은
 * 라우트 안쪽(`PrivateRoutes`)에 있다. 로그인 직후에는 **둘 다 뜨는 조건**이
 * 동시에 성립한다 — 업데이트 팝업은 로그인 전환에, 브리핑 팝업은 경로 진입에
 * 반응하기 때문이다.
 *
 * 겹치면 원장님은 무엇을 닫은 건지 모르고, 뒤에 있던 팝업이
 * 「닫았는데 또 뜬다」로 읽힌다. 업데이트 소식을 먼저 보이고, 닫으면
 * 그때 브리핑 팝업이 뜨게 순서를 잡는다.
 *
 * 기본값 `false` — 이 프로바이더 밖에서 쓰이면 「막지 않음」이 된다.
 * 팝업을 못 띄우는 쪽이 아니라 **예전과 같이 동작하는 쪽**이 안전하다.
 */
export const UpdatePopupOpenContext = createContext(false);

export const useUpdatePopupOpen = (): boolean => useContext(UpdatePopupOpenContext);
